import { render, staticRenderFns } from "./ArrowDownNarrowWideIcon.vue?vue&type=template&id=5511c712"
import script from "./ArrowDownNarrowWideIcon.vue?vue&type=script&lang=js"
export * from "./ArrowDownNarrowWideIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports